import { Typography } from 'primsell-shared-layer/components'
import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 60px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Image = styled.img`
  width: 169px;
  height: 169px;
`

export const MessageTypography = styled(Typography)`
  max-width: 330px;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  text-align: center;
`
